import { ExternalBlogMedia } from 'src/types'
import ImageWithFallback from 'src/components/ImageWithFallback'

const BlogVideoImage: React.FC<{ media: ExternalBlogMedia }> = ({ media }) => {
  return (
    <div className="blog__list-item-media js-oembed-container" data-img={media.image?.url}>
      {media.optionEmbed ? (
        <div dangerouslySetInnerHTML={{ __html: media.optionEmbed.html }}></div>
      ) : media.image ? (
        <div className="tw-relative">
          <ImageWithFallback src={media.image.url} alt={media.image.alt || media.title || ''} fill className="tw-object-cover tw-block tw-static tw-w-full tw-h-88 md:tw-h-64 tw-rounded-lg tw-border-2 tw-border-solid tw-border-brand-green" unoptimized={true} />
        </div>
      ) : ''}
    </div>
  )
}

export default BlogVideoImage
